import React, { useState, useEffect } from "react";
import BranchForm from "./branch_form";
import Datatables from "../../../utils/table/datatable";
import { BranchColumns } from "helpers/DatatableColumns";
import { BRANCH } from "helpers/url_helper";
import { get } from "helpers/api_helper";

const Branches = () => {
    const [ isForm , setIsForm ] = useState(false);
    const [ branchList, setBranchList ] = useState([]);
    const [ pagination, setPagination ] = useState({
        page: 1,
        limit: 10,
        search: '',
    })
    
    const toggleForm = () => {
        setIsForm(!isForm);
        if(isForm == false){
            getBranchList();
        }   
    }

    const getBranchList = async () => {
        const { success, data } = await get(`${BRANCH}?limit=${pagination.limit}&page=${pagination.page}&search=${pagination.search}`);
        if(success){
            setBranchList(data);
        }
    }

    useEffect(() => {
        const fetchData = setTimeout(() => {
            getBranchList();
        }, 500);

        return () => clearTimeout(fetchData);
    }, [pagination.page, pagination.limit, pagination.search]);

    return (
        isForm ? <BranchForm cb={toggleForm} /> :
            <Datatables 
                isSearch={true}
                columns = {BranchColumns}
                showTableOnly={true}
                rowsLength={branchList?.totalRows || 0}
                rows = {branchList?.data || []}
                keyField={'id'}
                handleAddButton={toggleForm}            
                title = "All Branches"
                loading = {false}
                isAdd = {true}
                isTableHead = {true}
                ssr={(page) => setPagination(page)}
            />
    );
};

export default Branches;